import { configSelector } from '../../redux/app.ts';
import { locationProvider } from '../locationProvider.ts';

/**
 * Sends the user to the login page, keeping the current page as the ReturnUrl.
 * The ReturnUrl is relative, matching what the server sends when it redirects to login.
 */
export function redirectToLogin(): void {
  const { loginUrl } = configSelector() ?? {};

  if (!loginUrl) {
    throw new Error('loginUrl is not configured.');
  }

  if (locationProvider.pathname === new URL(loginUrl, document.baseURI).pathname) {
    return;
  }

  const { pathname, search, hash } = locationProvider;

  locationProvider.href = `${loginUrl}?ReturnUrl=${encodeURIComponent(`${pathname}${search}${hash}`)}`;
}
